/** 
 * Correções para fazer o aplicativo funcionar em navegadores
 * antigos.
 */ 

import Modernizr from 'modernizr'

if (!Modernizr.es6object) {
	require('es6-shim');
}

require('es6-symbol/implement');



// WEBPACK FOOTER //
// ./src/fixes.js